import { PropTypes } from 'prop-types';
import React, { useState } from 'react';
import { Table, Typography, Tag } from 'antd';
import { formatDate } from '../../utils/date';
import { APP_TERMS } from '../../app-terms';
import { useUserLocale } from '../../hooks/useLocale';
import StrikeThroughText from './StrikeThroughText';
import { EditableCell, EditableRow } from './EditInvoiceService';

const { Text } = Typography;

const EditRadiologistInvoiceService = ({ onChange, value }) => {
  const [dataSource, setDataSource] = useState(value);
  const userLocale = useUserLocale();

  const defaultColumns = [
    {
      title: 'Sl No.',
      dataIndex: 'index',
      render: (_, record, index) => {
        return (
          <StrikeThroughText
            strikeThrough={record?.isDeleted}
            value={index + 1}
          />
        );
      },
    },
    {
      title: 'Case ID',
      dataIndex: 'caseId',
      render: (text, record) => {
        return (
          <StrikeThroughText strikeThrough={record?.isDeleted} value={text} />
        );
      },
    },
    {
      title: 'Name',
      dataIndex: 'casePatientName',
      render: (text, record) => {
        return (
          <StrikeThroughText strikeThrough={record?.isDeleted} value={text} />
        );
      },
    },
    {
      title: 'Case Date',
      dataIndex: 'caseCreatedAt',
      render: (text, record) => {
        const value = formatDate(text, APP_TERMS.date_1_format, userLocale);
        return (
          <StrikeThroughText strikeThrough={record?.isDeleted} value={value} />
        );
      },
    },
    {
      title: 'Payment Status',
      dataIndex: 'paymentStatus',
      render: (value, record) => {
        const isPaid = !!value;
        const color = isPaid ? 'green' : 'red';
        const label = isPaid ? 'PAID' : 'UN-PAID';
        return (
          <Tag color={color}>
            <StrikeThroughText
              strikeThrough={record?.isDeleted}
              value={label}
            />
          </Tag>
        );
      },
    },
    {
      title: 'Unit Price($)',
      dataIndex: 'amount',
      editable: true,
      align: 'right',
    },
  ];

  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.invoiceServiceId === item.invoiceServiceId);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
    onChange?.(newData);
  };
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    };
  });
  return (
    <div>
      <Table
        components={components}
        rowClassName={() => 'editable-row'}
        bordered
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        rowKey={(record) => record?.invoiceServiceId}
        summary={(pageData) => {
          let totalAmount = 0;

          pageData.forEach(({ amount, isDeleted }) => {
            if (!isDeleted) {
              totalAmount += amount || 0;
            }
          });

          return (
            <Table.Summary.Row
              className="bg-light"
              style={{ fontWeight: 'bolder' }}
            >
              <Table.Summary.Cell index={0} colSpan={5}>
                Total
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1} colSpan={1} align="right">
                <Text type="danger">{totalAmount}</Text>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
      />
    </div>
  );
};
EditRadiologistInvoiceService.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.array,
};
export default EditRadiologistInvoiceService;
